export default __webpack_public_path__ + "static/cd-2dff61a21f0f958f14c1d48b7861da7c.svg";